module.exports = __webpack_public_path__ + "media/application/images/icons/scales-7824b2a131d0967df42b363ad1e85668.svg";